import React, { useState } from 'react';
import './Views.css';

const Views = ({ project }) => {
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'

  const views = [
    {
      id: 1,
      name: 'Overview',
      thumbnail: '/api/placeholder/200/150',
      isActive: false
    },
    {
      id: 2,
      name: 'V1',
      thumbnail: '/api/placeholder/200/150',
      isActive: true
    }
  ];

  return (
    <div className="views-container">
      <div className="views-header">
        <button className="create-view-btn">
          <i className="fas fa-plus"></i>
          <span>Create view</span>
        </button>
        
        <div className="view-mode-controls">
          <button 
            className={`mode-btn ${viewMode === 'grid' ? 'active' : ''}`}
            onClick={() => setViewMode('grid')}
          >
            <i className="fas fa-th"></i>
          </button>
          <button 
            className={`mode-btn ${viewMode === 'list' ? 'active' : ''}`}
            onClick={() => setViewMode('list')}
          >
            <i className="fas fa-list"></i>
          </button>
        </div>
      </div>

      <div className="views-content">
        {viewMode === 'grid' ? (
          <div className="views-grid">
            {views.map(view => (
              <div key={view.id} className={`view-card ${view.isActive ? 'active' : ''}`}>
                <div className="view-thumbnail">
                  <img src={view.thumbnail} alt={view.name} />
                  <div className="view-menu">
                    <i className="fas fa-ellipsis-v"></i>
                  </div>
                </div>
                <div className="view-name">{view.name}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="views-list">
            {views.map(view => (
              <div key={view.id} className={`view-list-item ${view.isActive ? 'active' : ''}`}>
                <div className="view-thumbnail-small">
                  <img src={view.thumbnail} alt={view.name} />
                </div>
                <div className="view-info">
                  <div className="view-name">{view.name}</div>
                  <div className="view-details">3D View</div>
                </div>
                <div className="view-menu">
                  <i className="fas fa-ellipsis-v"></i>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Views;
